import { RESTSerializer } from '@warp-drive/legacy/serializer/rest';

export default class Group extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    return modelName.replace(/^school-options\/group/, 'optionGroup');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(
      key.replace(/^optionGroup/, 'school-options/group'),
    );
  }

  normalize(model, hash, prop) {
    let defaults = {
      sequence: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
